import { getContext } from '@/context';

const LAUNCH_PARAM = 'isOnboarding';

let hasEnded = false;

/**
 * Whether this run came from the onboarding miniapp — the entitlement to free
 * generations, never the count, which only the server knows. Read from the
 * launch param, which the host keeps for the whole session, and false for good
 * once the free quota answers 429.
 */
const isOnboardingSession = (): boolean => {
  if (hasEnded) return false;

  try {
    const params = getContext().general.location.getState?.()?.params;
    const value = params?.[LAUNCH_PARAM];

    return (Array.isArray(value) ? value[0] : value) === 'true';
  } catch {
    return false;
  }
};

const endOnboardingSession = (): void => {
  hasEnded = true;
};

export { isOnboardingSession, endOnboardingSession };
